<template>
  <div>

        <el-button
          type="primary"
          @click="addGoodsChapter('直播')"
          icon="el-icon-plus"
          >添加小鹅通直播</el-button
        >

        <div style="width: 100%" class="draggable-tableaaa">
          <div style class="draggable-table">
            <div class="answer bor" style="width: 20%">所属课程</div>
            <div class="answer bor" style="width: 40%">名称</div>
            <div class="answer bor" style="width: 10%">授课老师</div>
            <div class="delete bor" style="width: 10%">版本号</div>
            <div class="answer bor" style="width: 10%">类型</div>
            <div class="delete bor" style="width: 10%">操作</div>
          </div>
          <draggable
            v-if="page.rows.length"
            v-model="page.rows"
            @update="datadragEnd"
            :options="{ animation: 500 }"
          >
            <!-- <transition-group> -->
            <div
              v-for="(element, index) in page.rows"
              :key="index"
              class="drag-item"
            >
              <div class="draggable-table">
                <el-tooltip
                  :open-delay="500"
                  class="item"
                  effect="dark"
                  :content="element.courseName"
                >
                  <div style="width: 20%" class="answer">
                    {{ element.courseName || "null" }}
                  </div>
                </el-tooltip>
                <el-tooltip
                  :open-delay="500"
                  class="item"
                  effect="dark"
                  :content="element.name"
                >
                  <div style="width: 40%" class="answer">
                    {{ element.name || "null" }}
                  </div>
                </el-tooltip>
                <div style="width: 10%" class="answer">
                  {{ element.teacher || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  {{ element.version || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  <span>{{ element.type || "null" }}</span>
                  <div v-if="element.powerList" style="display: inline">
                    <span class="line"></span>
                    <el-popover trigger="click" v-model="element.isPrpover">
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox
                          v-for="(item, index) in powerList"
                          :key="index"
                          :label="item.power"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <el-button
                        size="mini"
                        type="primary"
                        class="type-btn"
                        @click="sunmitType(element)"
                        >提交</el-button
                      >
                      <span slot="reference" @click="rangeCli(element)"
                        >范围<i class="el-icon-arrow-down el-icon--right"></i
                      ></span>
                    </el-popover>
                  </div>
                </div>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip :open-delay="500" class="item" effect="dark" :content="String(index+1)">
                  <div
                    style="width:13.3%"
                    class="answer mainColor"
                    @click="opConmon(element,1)"
                  >{{element.videoCount||0}}</div>
                </el-tooltip> -->
                <div style="width: 10%" class="delete">
                  <!-- <i
                      slot="reference"
                      class="el-icon-delete mainColor"
                      title="解绑"
                      @click="deleteGoodsItem(element.id)"
                  ></i>-->
                  <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="deleteGoodsItem(element.id)"
                    title="确定解绑吗？"
                  >
                    <el-button type="text" slot="reference">解绑</el-button>
                  </el-popconfirm>
                  <!-- <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    icon="el-icon-info"
                    iconColor="red"
                    @confirm="deleteGoodsItem(element.id)"
                    @cancel="deleteCancel"
                    title="确定解绑吗？"
                  >
                    <span slot="reference" class="mainColor">解绑</span>
                  </el-popconfirm> -->
                  <!-- <span
                    v-if="element.type == '录播'"
                    style="margin-left: 30px"
                    class="mainColor"
                    @click="opConmon(element, 1)"
                    >查看</span
                  > -->
                </div>
              </div>
            </div>
            <!-- </transition-group> -->
          </draggable>
          <div
            v-else
            style="
              text-align: center;
              line-height: 60px;
              color: #909399;
              border-bottom: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;
            "
          >
            暂无数据
          </div>
        </div>

    <el-dialog
      :title="`${isEdit ? '编辑' : '添加'}${liveTypeName}直播`"
      :visible.sync="addLiveVisible"
      width="60%"
      :before-close="handleCloseLiveDialog"
    >
      <el-form
        ref="liveForm"
        :model="liveForm"
        label-width="120px"
        :rules="liveRules"
      >
        <el-row>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="直播名" prop="liveName">
              <el-input
                v-model="liveForm.liveName"
                placeholder="请输入直播名"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="直播起止时间" prop="time">
              <el-date-picker
                style="width:100%"
                v-model="liveForm.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="timeChange"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="老师名" prop="liveTeacherName">
              <el-input
                v-model="liveForm.liveTeacherName"
                placeholder="请输入老师名称"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="老师头像" prop="liveTeacherImgUrl">
              <div class="editPointC">
                <el-upload
                  class="avatar-uploader-logo"
                  :action="fileObj.url"
                  :show-file-list="false"
                  ref="upload"
                  :before-upload="beforeUpload"
                  :on-success="UploadSuccess"
                  :headers="reqData"
                >
                  <img
                    class="avatar"
                    v-if="liveForm.liveTeacherImgUrl"
                    :src="liveForm.liveTeacherImgUrl"
                    alt=""
                  />
                  <i
                    class="el-icon-plus avatar-uploader-icon avatar"
                    v-else
                  ></i>
                </el-upload>
                <div class="paySetting-tips">
                  支持JPG、PNG格式，每张图片不超过2M
                </div>
              </div>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="串流码" prop="liveStreamingParam">
              <el-input
                v-model="liveForm.liveStreamingParam"
                placeholder="请输入串流码"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="handleCloseLiveDialog">取 消</el-button>
        <el-button @click="addLiveItem" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加小鹅通直播"
      :visible.sync="addVideoVisible"
      width="800px"
      left
    >
      <el-form
        ref="searchForm"
        :model="videoSearchForm"
        :label-width="formLabelWidths"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input
              v-model="videoSearchForm.search_content"
              placeholder="请输入视频名称"
              auto-complete="off"
            ></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="xiaoETongLivePageList()"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="videocoursePage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column prop="imgUrl" label="封面">
          <template slot-scope="scope">
            <img
              width="200px"
              height="80px"
              :src="scope.row.imgUrl"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名字" width="200"></el-table-column>
        <el-table-column prop="aliveStartAt" label="开始时间"></el-table-column>
        <el-table-column prop="aliveStopAt" label="结束时间"></el-table-column>
<!--        <el-table-column prop="alive_type" label="直播类型">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.alive_type === 10">横屏直播</span>-->
<!--            <span v-if="scope.row.alive_type === 11">竖屏直播</span>-->
<!--            <span v-if="scope.row.alive_type === 12">语音直播</span>-->
<!--            <span v-if="scope.row.alive_type === 13">录播直播</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="aliveState" label="直播状态">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveState === 0">未开始</span>
            <span v-if="scope.row.aliveState === 1">直播中</span>
            <span v-if="scope.row.aliveState === 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="liveStreamingParam" label="串流码" width="100"></el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50]"
        style="margin-top: 20px; text-align: right"
        :total="videocoursePage.total"
        :page-size="videocoursePage.pageSize"
        :current-page="videocoursePage.pageNumber"
        @size-change="videoSizeChange"
        @current-change="videoCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addVideoVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch('2')" type="primary">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    hasLiveRoom: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    page: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chapterListType: "",

      liveForm: {
        liveType: "",
        liveName: "",
        liveTeacherName: "",
        liveTeacherImgUrl: "",
        liveBeginTime: "",
        liveEndTime: "",
        time: [],
        // 小鹅通
        liveStreamingParam: "",
      },
      liveRules: {
        liveName: [
          { required: true, message: "请输入直播名称", trigger: "blur" },
        ],
        liveTeacherName: [
          { required: true, message: "请输入老师名称", trigger: "blur" },
        ],
        liveTeacherImgUrl: [
          { required: true, message: "请上传老师头像", trigger: "change" },
        ],
        time: [
          { required: true, message: "请选择直播时间", trigger: "change" },
        ],
        liveStreamingParam: [
          { required: true, message: "请输入直播串流码", trigger: "blur" },
        ],
      },
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      liveType: 1,
      liveTypeName: "保利威",
      isEdit: false,

      addLiveVisible: false,
      activeName: "first",

      addVideoVisible: false,
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      videoSearchForm: {},
      formLabelWidths: "100px",
      multipleSelection: "",
      type: "",
      searchForm: {},
      liveSearchForm: {
        search_content: "",
      },
    };
  },
  watch: {
    page(val) {
      console.log(val);
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  methods: {
    handleClick({ index }) {
      if (index == "0") {
        this.$emit("getData");
      } else {
        this.pageList();
      }
    },
    videoSizeChange(pageSize) {
      this.videocoursePage.pageSize = pageSize;
      this.xiaoETongLivePageList();
    },
    videoCurrentChange(pageNumber) {
      this.videocoursePage.pageNumber = pageNumber;
      this.xiaoETongLivePageList();
    },
    // second
    selectionChange(val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.newId,
        goodsId: this.id,
        type: this.type,
      }));
    },
    addGoodsChapter(chapterListType) {
      this.chapterListType = chapterListType;
      this.type = chapterListType + "课程";
      this.xiaoETongLivePageList();
      this.addVideoVisible = true;
    },
    xiaoETongLivePageList() {
      this.loading = true;
      this.videoSearchForm.page_size = this.videocoursePage.pageSize;
      this.videoSearchForm.page = this.videocoursePage.pageNumber;
      if(this.videoSearchForm.page_size >50){
        this.$message.error("每页最大数量50条!");
      }
      this.api.xiaoETongLiveInfo.pageList(this.videoSearchForm).then(result => {
        this.loading = false;
        this.videocoursePage.rows = result.data.data.list;
        this.videocoursePage.total = result.data.data.total;
      }).catch(error => {
        console.log(error);
      });
    },
    addGoodsItemBatch(liveType) {
      this.api.goodsItem
        .addGoodsItemBatch(this.ids, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
          liveType: liveType,
        })
        .then((result) => {
          if (result.success) {
            this.addVideoVisible = false;
            this.addSubjectVisible = false;
            this.addChapterVisible = false;
            this.addLiveVisible = false;
            this.addActualOperationVisible = false;
            this.pageList();
            this.$message.success(result.message);
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    videocoursePageList() {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.videoSearchForm.sortName = this.videocoursePage.sortName;
      this.videoSearchForm.sortOrder = this.videocoursePage.sortOrder;
      this.videoSearchForm.subjectId = this.$route.query.subjectId;
      this.videoSearchForm.type = "直播";
      this.api.videoCourse
        .pageList(this.videoSearchForm)
        .then((result) => {
          this.videocoursePage.rows = result.data.records;
          this.videocoursePage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteGoodsItem(vId) {
      this.api.goodsItem.deleteGoodsItem([{ id: vId }]).then((result) => {
        this.pageList();
        this.$message.success("解绑成功");
      });
    },
    // opConmon(row, sty) {
    //   this.bindVisible = true;
    //   this.comMonid = sty == 1 ? row.objectId : row.id;
    //   this.typeName = row.type;
    //   this.pageList1(row.showState);
    // },
    //first
    openLiveDialog(type) {
      this.liveType = type;
      this.liveTypeName = type == 1 ? "保利威" : type == 2 ? "小鹅通" : "民生";
      this.addLiveVisible = true;
      this.isEdit = false;

      this.liveForm = {
        liveType: "",
        liveName: "",
        liveTeacherName: "",
        liveTeacherImgUrl: "",
        liveBeginTime: "",
        liveEndTime: "",
        time: [],
        liveStreamingParam: "",
      };
    },
    // 上传
    UploadSuccess(res, file, fileList, val) {
      this.liveForm.liveTeacherImgUrl = res.data;
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 时间
    timeChange(e) {
      console.log(e,2345);
      this.liveForm.liveBeginTime = e[0];
      this.liveForm.liveEndTime = e[1];
    },
    handleCloseLiveDialog() {
      this.addLiveVisible = false;
      this.$refs.liveForm.resetFields();
    },
    addLiveItem() {
      this.$refs.liveForm.validate((valid) => {
        if (valid) {
          if (!this.isEdit) {
            let body = Object.assign(
              {},
              { goodsId: this.$route.query.goodsId, type: "直播" },
              this.liveForm
            );
            body.liveType = this.liveType;
            delete body.time;
            let params = {
              goodsId: this.$route.query.goodsId,
              addWay: this.$route.query.addWay,
            };
            this.api.live
              .addGoodsItemBatch([body], params)
              .then((res) => {
                if (res.code == 200 && res.success) {
                  this.$emit("getData");
                }
              })
              .finally(() => {
                this.handleCloseLiveDialog();
              });
          } else {
            this.api.live.updateGoodsItem(this.liveForm).then(res=>{
              if(res.code === 200){
               this.$emit("getData");
              }
            }).finally(()=>this.handleCloseLiveDialog())
          }
        }
      });
    },

    pageList(type) {
      console.log(this.page, 33);
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.id;
      this.searchForm.type = "录播";
      this.api.goodsItem
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editLive(item) {
      this.liveType = item.liveType;
      this.liveTypeName =
        item.liveType == 1 ? "保利威" : item.liveType == 2 ? "小鹅通" : "民生";
      this.liveForm = JSON.parse(JSON.stringify(item));
      // this.liveForm.time = [
      //   this.liveForm.liveBeginTime,
      //   this.liveForm.liveEndTime,
      // ];
      this.$set(this.liveForm,'time',[
        this.liveForm.liveBeginTime,
        this.liveForm.liveEndTime,
      ])
      console.log(this.liveForm,this.liveForm === item);
      this.isEdit = true;
      this.addLiveVisible = true;
    },
    datadragEnd(evt) {
      console.log(evt);
      let arr = [];
      this.data.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
    },
  },
};
</script>

<style lang="less" scoped>
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.avatar-uploader-logo {
  margin-right: 30px;
  .avatar {
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    background-color: #f8f8f8;
    border: 1px dashed #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods/liveComponent.vue